import {StrictMode} from 'react';
import ReactDOM from 'react-dom';
import 'url-search-params-polyfill';
import {BrowserRouter} from "react-router-dom";
import {toast} from "react-toastify";
import {ChakraProvider} from "@chakra-ui/react"

import chakraTheme from "./components/custom_theme";

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import './style/index.css';
import App from './app';
import init from "./init";

const app = init(import.meta.hot?.data?.initialState);
if (import.meta.env.DEV) {
    window.app = app;
    window.toast = toast;
}

ReactDOM.render(
    <StrictMode>
        <BrowserRouter>
            <ChakraProvider resetCSS theme={chakraTheme} >
                <App {...app} />
            </ChakraProvider>
        </BrowserRouter>
    </StrictMode>,
    document.getElementById('root')
);

if (import.meta.env.PROD) {
    // Register service worker to make app work offline and load faster.
    serviceWorkerRegistration.register({
        onRegister: app.actions.serviceWorkerRegistered,
        onUpdate: app.actions.serviceWorkerUpdateReady
    });
} else {
    serviceWorkerRegistration.unregister();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (import.meta.hot) {
    import.meta.hot.accept();
    
    // Store app state before HMR update
    import.meta.hot.dispose((data) => {
        data.initialState = app.store.getState();
    });
}
